import { ISpinnerButton } from "../../core/types/types";
import flavourConfig from "../../environment/flavourConfig";
import DotSpinner from "../DotSpinner/DotSpinner";

const SpinnerButton: React.FC<ISpinnerButton> = ({
  formId,
  extraStyling = "w-24 xl:w-28",
  isLoading,
  disabled = false,
  onClick,
  children,
}: ISpinnerButton) => {
  return (
    <button
      form={formId}
      disabled={disabled}
      onClick={onClick}
      className={`${extraStyling} bg-${
        flavourConfig.secondaryColor
      } transition duration-150 ease-in-out rounded text-white focus:bg-${
        flavourConfig.secondaryColorLight
      } focus:outline-none border focus:border-${flavourConfig.inputColor} ${
        disabled
          ? "bg-opacity-50"
          : `hover:bg-${flavourConfig.secondaryColorLight}`
      }`}
    >
      {isLoading ? <DotSpinner color="background-white-ie-fix" /> : children}
    </button>
  );
};

export default SpinnerButton;
